export const uploadMaxSizes = {
  avatar: {
    bytes: 5000000,
    toMo: () => {
      return uploadMaxSizes.avatar.bytes / 1000000;
    }
  }
};
